import React from 'react'

import { colors } from '@/styles/shared/typography'

type CheckBoxProps = {
  disabled?: boolean
  checked?: boolean
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  text?: string
  color?: keyof typeof colors
  className?: React.ComponentProps<'input'>['className']
}

const CheckBox = ({ disabled, checked, onChange, text, color, className = 'check' }: CheckBoxProps) => {
  return (
    <label
      className={`flex items-center border-none text-left ${color ? colors[color] : 'text-text-050'}
      ${text?.startsWith('전체') ? 'body-2 font-bold' : ''}
        `}
    >
      <input
        className={`${className} ${
          checked ? 'border-none bg-checkIcon checked:bg-main-050' : 'bg-transparent bg-none'
        }`}
        type="checkbox"
        disabled={disabled}
        checked={checked}
        onChange={onChange}
      />
      {text}
    </label>
  )
}

export default CheckBox
